import { useAuthContext } from '@contexts/authContext'
import ProfileNAvigateAvatar from '@elements/ProfileNavigateAvatar'
import { isAvatarSrc, thumbnailSmallBlue } from '@utils/thumbnails'

const AuthenticatedAvatar = ({ style, ...rest }) => {
  const { state: { user } } = useAuthContext()

  return (
    <ProfileNAvigateAvatar
      uuid={user?.uuid}
      src={thumbnailSmallBlue(user?.socialMedia?.thumbnail, user?.defaultAvatar)}
      style={{ filter: isAvatarSrc('small', user?.socialMedia?.thumbnail, user?.defaultAvatar) && 'grayscale(100%) contrast(120%)', ...style }}
      {...rest}
    />
  )
}

export default AuthenticatedAvatar
